import {datadogRum} from '@datadog/browser-rum';

import {assertAndContinue} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import APIUtil from 'util/APIUtil';

// When we receive a route change request for a route we don't know about, assert a warning and update the
// route to this view name so subsequent events don't get associated with the previous route.
const UNKNOWN_ROUTE = 'unknown_route';

const DatadogUtil = {
  unknownRoute: UNKNOWN_ROUTE,
  /**
   * Declare the start of a view (initial load or SPA route change) in DataDog RUM.
   *
   * @param viewName the view name that will appear in the DataDog RUM dashboard.
   */
  startRUMView(viewName: string): void {
    if (!_customRUMRoutingEnabled()) {
      return;
    }
    datadogRum.startView(viewName);
  },

  /**
   * Start a RUM route for the folder item editor endpoint. The name of the route in the RUM dashboard will
   * reflect the model type of the item opened.
   *
   * @param apiId the API ID of the resource that will open in the editor.
   */
  startFolderItemEditRUMView(apiId: string): void {
    _startFolderItemRUMView(apiId, 'edit');
  },

  /**
   * Start a RUM route for the folder item editor endpoint. The name of the route in the RUM dashboard will
   * reflect the model type of the item opened.
   *
   * @param apiId the API ID of the resource that will open in the editor.
   */
  startFolderItemViewerRUMView(apiId: string): void {
    _startFolderItemRUMView(apiId, 'view');
  },
};

function _startFolderItemRUMView(apiId: string, action: string): void {
  if (!_customRUMRoutingEnabled()) {
    return;
  }

  const modelType = APIUtil.apiIdToMaybeType(apiId);
  if (modelType == null) {
    assertAndContinue(false, `expected api id ${apiId} to map to valid type`);
    DatadogUtil.startRUMView(UNKNOWN_ROUTE);
    return;
  }

  DatadogUtil.startRUMView(`${modelType}_${action}`);
}

function _customRUMRoutingEnabled(): boolean {
  return BenchlingConfig.PERF_ENABLE_REAL_USER_MONITORING;
}

export default DatadogUtil;
